<template>
    <div class="col-sm-4" v-if="can('trips.*','reports.dispatcher_one')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n('Dispatching')}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/trips" tag="li" v-if="can('trips.*')">
                        <a href="#" title="">{{i18n("Trips")}}</a>
                    </router-link>
                    <router-link to="/reports/dispatcher" tag="li" v-if="can('reports.dispatcher_one')">
                        <a href="#" title="">{{i18n("Reporting")}}</a>
                    </router-link>
<!--
                    <router-link to="/" tag="li" v-if="can('reports.dispatcher_one')">
                        <a href="#" title="">Отчетность</a>
                    </router-link>
-->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DispatchingCard"
    }
</script>

<style scoped>

</style>
